import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { IngresosArrendamientosModalComponent } from '../ingresos-arrendamientos/ingresos-arrendamientos-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { DParametroPolitica } from '@dian/api-basicos-parametricas';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { IngresosComercianteModalComponent } from '../ingresos-comerciante/ingresos-comerciante-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [

  { text: "1", active: true, completed: false, tooltip: 'Ingresos Retiró ahorros de cuentas AFC, FVP o AVC', listHelp: ['367'] }
];



const tableStructure = [
  { id: 'pagador', title: 'Pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'nombreRenta', title: 'Renta' },
  { id: 'valor', title: 'Valor' }

];


class Form1 {
  id: number;
  idSugerida: number;
  pagador: string;
  origen: string;
  renta: string;
  nombreRenta: string;
  retencion: string;
  valor: string;

}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  //  selector: 'app-patrimonio-patrimonio-ingresos-AFC-OTROS-modal',
  selector: 'app-ingresos-ingresos-retiro-AFC-OTROS-modal',
  //  templateUrl: './patrimonio-ingresos-modal-AFC-OTROS.component.html',
  templateUrl: './ingresos-retiro-modal-AFC-OTROS.component.html',
  //  styleUrls: ['./patrimonio-ingresos-modal-AFC-OTROS.component.css'],
  styleUrls: ['./ingresos-retiro-modal-AFC-OTROS.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
//export class PatrimonioIngresosAFCOTROSModalComponent extends HandlerModal implements OnInit {
export class IngresosRetiroAFCOTROSModalComponent extends HandlerModal implements OnInit {



  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  public tiposRentaAFC = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  casillaLimpiada: boolean = false;
  casillaLimpiada2: boolean = false;


  saveModel = new EventEmitter();
  listaTipoRenta: any;
  public showSave: boolean;
  tablaArt73: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  modoAdquisionList = [{ id: '1', nombre: "Compra/Venta" }, { id: '2', nombre: "Leasing" }];
  parametroTipoRenta: DParametroPolitica = new DParametroPolitica();
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    public dialogRef: MatDialogRef<IngresosRetiroAFCOTROSModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    console.log("parametro parametrotiporenta" + this.parametroTipoRenta);
    console.log("parametro listaTipoRenta" + this.listaTipoRenta);
    const valorParPolitica = this.parametroTipoRenta.valor.split(',');
    // const valorParPolitica = this.parametroTipoRenta.valor.split(',').map(Number).filter(valor => valor >= 2 && valor <= 4);
    this.listaTipoRenta = this.listaTipoRenta.filter(item => valorParPolitica.includes(item.valor));
    this.listaTipoRenta.forEach(item => {
      item.mostrar = true;
    });


    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {

  }

  limpiarValor() {
    if (this.modelForm.valor === '0' && !this.casillaLimpiada) {
      this.modelForm.valor = null;
      this.casillaLimpiada = true;
    }
  }

  limpiarRetencion() {
    if (this.modelForm.retencion === '0' && !this.casillaLimpiada2) {
      this.modelForm.retencion = null;
      this.casillaLimpiada2 = true;
    }
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;
    this.modelForm.pagador = "";
    this.modelForm.origen = "";
    this.modelForm.renta = "";
    this.modelForm.nombreRenta = "";
    this.modelForm.retencion = "0";
    this.modelForm.valor = "0";
    // this.modelForm.retenciones="0";
    //   this.reloadSelArticulos(); //Se comentariza para AFC
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_368 == undefined) {

      this.model.doc.cuerpo.cc_id_368 = [];//pagador
      this.model.doc.cuerpo.cc_id_369 = []; //origen
      this.model.doc.cuerpo.cc_id_370 = []; //tipo de renta
      this.model.doc.cuerpo.cc_id_371 = []; //valor
      this.model.doc.cuerpo.cc_id_364 = []; //Retención
      this.model.doc.cuerpo.cs_id_372 = "0"; //Total

    }
  }


  public operacionCs372() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      //if(this.dataSourceBody[i].origen == "2")
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma);
      /*   else
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valCatastral, suma); */
    }
    if (suma)
      this.model.doc.cuerpo.cs_id_372 = suma;
    else
      this.model.doc.cuerpo.cs_id_372 = '0';
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 372:
        this.operacionCs372();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    // this.reloadSelArticulos(); AFC

  }

  // operacionCs372(){
  //   this.model.doc.cuerpo.cs_id_372 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_372,true);
  // }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_368.length; i++) {
      this.modelForm.id = i;
      this.modelForm.pagador = this.model.doc.cuerpo.cc_id_368[i].v;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_369[i].v;
      this.modelForm.renta = this.model.doc.cuerpo.cc_id_370[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_364[i].v; 
      //this.modelForm.nombreRenta= this.tiposRentaAFC[ this.model.doc.cuerpo.cc_id_370[i].v-1].nombre;
      if (this.listaTipoRenta[this.model.doc.cuerpo.cc_id_370[i].v - 1])
        this.modelForm.nombreRenta = this.listaTipoRenta[this.model.doc.cuerpo.cc_id_370[i].v - 1].nombre;

     
      this.modelForm.valor = this.model.doc.cuerpo.cc_id_371[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs372();
  }

  protected initializeTablaDesdeSugerida() {
    let indexModel = this.model.doc.cuerpo.cc_id_368.length;

    if (indexModel == 0) {
      //const fieldsRecovery = ['VAR_4044','VAR_4049','VAR_4050','VAR_3132','VAR_4052','VAR_4054','VAR_1066','VAR_4053','VAR_4215','VAR_4214','VAR_4217','VAR_4218','VAR_4219','VAR_4216','VAR_7412'];
      const fieldsRecovery = ['VAR_1087', 'VAR_1090'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);

      if (resData) {

        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {

            this.modelForm.id = indexModel;
            //this.modelForm.idSugerida=this.data.sugerida[i].idSugerida;
            // this.modelForm.pagador=this.data.sugerida[i].pagador;

            this.modelForm.pagador = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen = "0";
            this.modelForm.renta = "1";
            //  this.modelForm.nombreRenta= this.listaTipoRenta[ this.model.doc.cuerpo.cc_id_370[i].v-1].nombre;
            this.modelForm.nombreRenta = this.listaTipoRenta[Number(this.modelForm.renta) - 1].nombre;
            // this.modelForm.valor= this.data.sugerida[i].valor;
            this.modelForm.valor = String(resData[i].item.value[j]);
            if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelForm.valor, "0")) {
              this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valor, "-1", true);
            }
            this.modelForm.origen = "0";

            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          }

        }

      }
    }

    this.operacionCs372();
  }

  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_368[this.modelForm.id].v = this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_369[this.modelForm.id].v = this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_370[this.modelForm.id].v = this.modelForm.renta.toString();
    this.model.doc.cuerpo.cc_id_371[this.modelForm.id].v = this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_364[this.modelForm.id].v=this.modelForm.retencion.toString();
    //  this.model.doc.cuerpo.cc_id_194[this.modelForm.id].v=this.modelForm.retenciones.toString();
    this.operacionCs372();

  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_368.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_369.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_370.push({ it: i, v: this.modelForm.renta.toString() });
    this.model.doc.cuerpo.cc_id_364.push({it: i, v:this.modelForm.retencion.toString()});
    this.model.doc.cuerpo.cc_id_371.push({ it: i, v: this.modelForm.valor.toString() });
    //  this.model.doc.cuerpo.cc_id_194.push({it: i, v:this.modelForm.retenciones.toString()});
    this.operacionCs372();
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_368.splice(index, 1);
    this.model.doc.cuerpo.cc_id_369.splice(index, 1);
    this.model.doc.cuerpo.cc_id_370.splice(index, 1);
    this.model.doc.cuerpo.cc_id_371.splice(index, 1);
    this.model.doc.cuerpo.cc_id_364.splice(index,1);
    //  this.model.doc.cuerpo.cc_id_194.splice(index,1);



    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_368.length; i++) {
      this.model.doc.cuerpo.cc_id_368[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_369[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_370[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_371[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_364[i].it = i + 1;
      //  this.model.doc.cuerpo.cc_id_194[i].it=i+1;
    }
    this.operacionCs372();
  }


  public validateFormCompleted(): boolean {
    return this.modelForm.pagador == undefined || this.modelForm.pagador == "" ||
      this.modelForm.origen == undefined || 
      this.modelForm.renta == undefined || this.modelForm.renta == "" ||
      this.modelForm.retencion==undefined || 
      this.modelForm.valor == undefined


  }


  public redondearFormData() {
    this.modelForm.valor = this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(), true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);


  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();


  }

  // reloadListTipoRent(){
  //   const concepto = this.modelForm.renta;
  //   this.listaTipoRenta.forEach(item => {
  //     item.mostrar = false;
  //     if((concepto=="1" || concepto=="2" || concepto=="4")){
  //       item.mostrar=true;
  //     }else if((concepto=="3" || concepto=="6") && (item.valor==1 || item.valor==2)){
  //       item.mostrar=true;
  //     }else if(concepto=="5" && (item.valor==3 || item.valor==4)){
  //       item.mostrar=true;
  //     }
  //   });


  // }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        // const existeValor = this.model.doc.cuerpo.cc_id_368.some(item => item.v === this.modelForm.pagador);

        // if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
        //   this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
        //   this.editModeloDesdeForm();
        // }else if(this.modelForm.origen=="0"){ //editando sugerida
        //   this.modelForm.origen = "1";
        //   this.modelForm.id = this.model.doc.cuerpo.cc_id_368.length;
        //   this.addToModeloDesdeForm();
        // }
        // this.modelForm.nombreRenta = this.tiposRentaAFC[Number(this.modelForm.renta)-1].nombre;
        this.modelForm.nombreRenta = this.listaTipoRenta[Number(this.modelForm.renta) - 1].nombre;
        // this.editModeloDesdeForm();
        if (this.modelForm.origen == "0") {
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_368.length;
       // this.modelForm.pagador = "Contribuyente"

        this.modelForm.origen = "2";

        // this.modelForm.nombreRenta = this.tiposRentaAFC[Number(this.modelForm.renta)-1].nombre;
        this.modelForm.nombreRenta = this.listaTipoRenta[Number(this.modelForm.renta) - 1].nombre;
        this.dataSourceBody.push(this.modelForm);
        // this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs372();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs372();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      //   this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  /*   public validateRbQuestions(val: string) {
      this.modelForm.aplicoArt73 = val;
      this.calcularValoresForm();
    } */

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /*  public validateStepHabilitado(indexS:number):boolean{
     let habilitado = true;
     return habilitado;
   } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    /* this.changeStepLocal(0); */
    this.initializeTablaDesdeModelo();
    this.operacionCs372();

    this.dialogRef.close("");
  }
  public guardar() {
    
    this.model.doc.cuerpo.cc_id_368 = undefined;
    this.inicializeModelo();



    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs372();


    //Dependencias
   
    this.saveModel.emit(true);

    this.closeModal();

  }



  public borrarTabla() {
    this.dataSourceBody = [];
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-modal-retiro-AFC-OTROS/ingresos-retiro-modal-AFC-OTROS.component.ts